module.exports = __webpack_public_path__ + "static/luk-vermeulen-8e6b1440781ae1f2b693afbc853e8001.jpg";